import { createContext, useCallback, useContext, useState } from "react";

const ProfileModalContext = createContext({ open: false, openProfile: () => {}, closeProfile: () => {} });

export function ProfileModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openProfile = useCallback(() => setOpen(true), []);
  const closeProfile = useCallback(() => setOpen(false), []);
  return (
    <ProfileModalContext.Provider value={{ open, openProfile, closeProfile }}>
      {children}
    </ProfileModalContext.Provider>
  );
}

export const useProfileModal = () => useContext(ProfileModalContext);
